import { render } from "./TypeSwitcher.vue?vue&type=template&id=18f4cb66&scoped=true&ts=true"
import script from "./TypeSwitcher.vue?vue&type=script&lang=ts"
export * from "./TypeSwitcher.vue?vue&type=script&lang=ts"

import "./TypeSwitcher.vue?vue&type=style&index=0&id=18f4cb66&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f4cb66"]])

export default __exports__